module.exports = __webpack_public_path__ + "img/icon_line_tab3.47c4c160.png";